import React, { useState, useEffect } from 'react';
import styles from './style.module.scss';
import Modal from '../modal';
import config from '../../../config';
import Spinner from '../../components/Loaders/Spinner';
import Button from '../../components/new-button';

const STRATUS_URL = config.paymentcloud.STRATUS_URL;

function ShowFileModal({ isOpen, onClose, name, path, type }) {

  const [loading, setLoading] = useState(true);
  const [blobUrl, setBlobUrl] = useState(null);

  const fileUrl = `${STRATUS_URL}get-file-by-path?path=${path}`;

  // Define supported file types and their handlers
  const supportedFileTypes = {
    pdf: 'pdf',
    jpg: 'image',
    jpeg: 'image',
    png: 'image',
    svg: 'image'
  };

  const fileType = type.toLowerCase();
  const isSupported = fileType in supportedFileTypes;
  const fileCategory = supportedFileTypes[fileType];

  // Fetch file as blob for preview when modal opens
  useEffect(() => {
    if (isOpen && isSupported) {
      setLoading(true);
      setBlobUrl(null);
      fetch(fileUrl, { credentials: 'same-origin' })
        .then((res) => res.blob())
        .then((blob) => {
          const url = URL.createObjectURL(blob);
          setBlobUrl(url);
        })
        .catch(() => {
          setLoading(false);
        });
    } else if (isOpen) {
      setLoading(false);
    }

    return () => {
      if (blobUrl) {
        URL.revokeObjectURL(blobUrl);
      }
    };
  }, [isOpen, path]);

  const handleLoad = () => setLoading(false);

  const renderFileContent = () => {
    // For unsupported files, hide spinner immediately
    if (!isSupported) {
      return (
        <div className={styles.msgContainer}>
          <svg className={styles.icon} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m6.75 12H9m1.5-12H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z" />
          </svg>
          <div className={styles.message}>
            This file type is not supported for preview
            <span>Please use the download button below to view the file</span>
          </div>
        </div>
      );
    }

    if (!blobUrl) return null;

    if (fileCategory === 'pdf') {
      return (
        <embed
          src={blobUrl}
          className={styles.fileSrc}
          onLoad={handleLoad}
        />
      );
    }

    if (fileCategory === 'image') {
      return (
        <div className={styles.imgContainer}>
          <img
            src={blobUrl}
            className={styles.docImage}
            onLoad={handleLoad}
            alt={name}
          />
        </div>
      );
    }

    return (
      <div className={styles.msgContainer}>
          <svg className={styles.icon} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m6.75 12H9m1.5-12H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z" />
          </svg>
        <div className={styles.message}>
          Browser does not support this file type
          <span>Please download the file to view it</span>
        </div>
      </div>
    );
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      header={`File: ${name}`}
      size="lg"
      customClass={styles.modal}
    >
      <div className={styles.fileContainer}>
        {loading && (
          <div className={styles.spinnerWrapper}>
            <Spinner />
          </div>
        )}
        <div className={styles.fileContent}>
          {renderFileContent()}
        </div>

        <div className={styles.actions}>
          <Button
            type="button"
            variant="secondary"
            onClick={onClose}
          >
            Cancel
          </Button>
          <Button
            type="submit"
            variant="primary"
            onClick={() => {
              window.open(fileUrl, '_blank');
            }}
          >
            Download
          </Button>
        </div>
      </div>
    </Modal>
  )
}

export default ShowFileModal;
